import React from "react";
import { Link } from "react-router-dom";

const N_MARK = "https://static.prod-images.emergentagent.com/jobs/5ff5578d-6654-461d-8447-9788eb827ab5/images/cf5c610b2d9b2fea3a4b30d526bc8cf2416c127ae46d78b1fdd44b1232392ff7.jpeg";

export function LogoMark({ size = 36, className = "" }) {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-[11px] overflow-hidden shrink-0 ${className}`}
      style={{ width: size, height: size, background: "linear-gradient(160deg,#141a2e,#0d1120)" }}
      aria-hidden="true"
    >
      <img src={N_MARK} alt="" className="w-[78%] h-[78%] object-contain" style={{ filter: "drop-shadow(0 2px 6px rgba(124,58,237,0.45))" }} />
    </span>
  );
}

export function Logo({ to = "/", showWord = true, size = 36 }) {
  return (
    <Link to={to} className="flex items-center gap-2.5 group" data-testid="brand-logo">
      <LogoMark size={size} className="transition-transform duration-200 group-hover:scale-105" />
      {showWord && (
        <span className="font-display text-[19px] font-extrabold tracking-[-0.02em] text-ink lowercase">namable</span>
      )}
    </Link>
  );
}
